import {Component, ElementRef, HostListener, OnInit, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';

// services
import {ImageTypeValidation} from '../shared/services/image-type-validation';
import {UtilsService} from '../utils/utils.service';
import {CompanyDataServiceService} from './services/company-data-service.service';

// utils
import {AppConstants} from '../utils/constants';

// models
import {MyCompanyDataModel} from './models/my-company-data.model';
import {ImageSizeValidation} from "app/shared/services/image-size-validation";
import {UnsavedChangesComponent} from "../shared/unsaved-changes-component";
import {ImageModel} from 'app/shared/models/image.model';

@Component({
    selector: 'app-my-company-data',
    templateUrl: './my-company-data.component.html',
    styleUrls: ['./my-company-data.component.scss'],
    standalone: false
})

export class MyCompanyDataComponent implements OnInit, UnsavedChangesComponent {

  @ViewChild('fileInput', { static: true }) myFileInput: ElementRef;

  private updateMyCompanyDataForm: UntypedFormGroup;
  private myCompanyData: MyCompanyDataModel = new MyCompanyDataModel();
  private file: File;
  private confirmDeleteLogo: boolean;

  private disableForm = true;

  private homePath = AppConstants.homePage;

  public loading = false;
  private userSavedTheChanges: boolean = false;
  private fileModified: boolean = false;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private _router: Router,
    private _utilsService: UtilsService,
    private _companyDataServiceService: CompanyDataServiceService
  ) {
    this.updateMyCompanyDataForm = this._formBuilder.group({
      companyLogo: [
        {
          value: '',
          disabled: false
        }
      ],
    }, {
      validator: Validators.compose([
        ImageTypeValidation.ValidateType('companyLogo'),
        ImageSizeValidation.ValidateSize('companyLogo')
      ])
    });
  }

  ngOnInit() {
    this.loading = true;
    this._companyDataServiceService.getCustomerLogo()
      .subscribe((res: ImageModel) => {
        this.loading = false;
        if (res) {
          this.updateMyCompanyDataForm.controls.companyLogo.setValue(res.content);
          this.myCompanyData.logoName = res.name;
          this.myCompanyData.logoSizeInBytes = res.sizeInBytes;
          this.myCompanyData.logo = res.content;
          this.myCompanyData.logoContentType = res.contentType;
        }
      }, (error) => {
        this.loading = false;
      });
  }

  public getUpdateMyCompanyDataForm() {
    return this.updateMyCompanyDataForm;
  }

  public getMyCompanyData() {
    return this.myCompanyData;
  }

  public getDisableForm() {
    return this.disableForm;
  }

  public getHomePath() {
    return this.homePath;
  }

  public getLoading() {
    return this.loading;
  }


  public isDirty() {
    return this.fileModified && !this.userSavedTheChanges;
  }

  @HostListener('window:beforeunload')
  canUnloadWindow() {
    return !this.fileModified;
  }


  public onFileInputChange(event) {
    if (event.target.files && event.target.files[0]) {
      this.fileModified = true;
      this.disableForm = false;
      const image: any = new Image();
      this.file = event.target.files[0];
      const reader: FileReader = new FileReader();
      this.confirmDeleteLogo = false;

      reader.onloadend = (loadEvent: any) => {
        image.src = loadEvent.target.result;
        this.updateMyCompanyDataForm.controls.companyLogo.setValue(image.src);
      };

      reader.readAsDataURL(this.file);

      this.myFileInput.nativeElement.value = '';
    }
  }


  public updateCompanyData(formValues: any) {
    if (this.confirmDeleteLogo) {
      this.loading = true;
      this._companyDataServiceService.deleteCompanyData().subscribe(() => {
        this.loading = false;
        this.userSavedTheChanges = true;
        this.myCompanyData.logo = '';
        this.updateMyCompanyDataForm.reset();
        this.disableForm = true;
        this._router.navigateByUrl(AppConstants.homePage);
      }, (error) => {
        this.loading = false;
      });
    } else {
      this.loading = true;
      let imageUploadData = this._utilsService.getImageUploadData(this.file, this.updateMyCompanyDataForm.controls.companyLogo.value);

      this._companyDataServiceService.updateCustomerLogo(imageUploadData).subscribe(() => {
        this.loading = false;
        this.userSavedTheChanges = true;
        this.myCompanyData.logo = this.updateMyCompanyDataForm.controls.companyLogo.value;
        this.disableForm = true;
        this._router.navigateByUrl(AppConstants.homePage);
      }, (error) => {
        this.loading = false;
      });
    }
  }

  public removeLogo() {
    this.file = null;
    this.updateMyCompanyDataForm.controls.companyLogo.reset();
    this.fileModified = true;
    if (this.myCompanyData.logo) {
      this.disableForm = false;
      this.confirmDeleteLogo = true;
    } else {
      this.disableForm = true;
    }
  }

  public cancelBtn() {
    this.updateMyCompanyDataForm.reset();
    this._router.navigate([AppConstants.homePage]);
  }

}
